module.exports = __webpack_public_path__ + "static/img/charge-coupon-background.d26351d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/coupon/charge-coupon-background.png
// module id = K59V
// module chunks = 4